// Web environment configuration

const envConfig = {
  SUPABASE_URL: process.env.REACT_APP_SUPABASE_URL,
  SUPABASE_ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY,
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  EXPRESS_BACKEND_URL: process.env.REACT_APP_EXPRESS_BACKEND_URL,
  POSTHOG_KEY: process.env.REACT_APP_POSTHOG_KEY,
  POSTHOG_HOST: process.env.REACT_APP_POSTHOG_HOST,
};

export { envConfig };
